export default "https://cdn-static.gokick.com/assets/ba7f9a5518cadaf73eb1329111c0735c5df64124/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";